;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "5w6gm9w5w5d"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="5w6gm9w5w5d"]').get(0))({						url: "https://library.layouthub.com/HUB/files/Tm92LS0yMDE5/NTc0ODY0ODc5/First_release/pages/Cowi/about-us/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "clp55m6r1ph"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {



  $(this).find('.lh-info-question .lh-title-ques').on('click', function() {

      var _this = jQuery(this).closest('.lh-info-question');

      if(_this.hasClass('active')){

        _this.removeClass('active');

      }else{

        _this.addClass('active');

        _this.siblings('.active').removeClass('active');

      }

  });

   };						cb.bind($('section[data-section-id="clp55m6r1ph"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="clp55m6r1ph"]').get(0))({						url: "https://library.layouthub.com/HUB/files/Tm92LS0yMDE5/NTc0ODY0ODc5/First_release/pages/Faqs5/Faqs/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');